import ExtendedTeam from './ExtendedTeam';

export default ExtendedTeam;
